import "../../Subbundle.css";
import "./Accessing.css";
import React from "react";
import { Link } from "react-router-dom";

class Block extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			blockValue: Math.floor(Math.random() * 100),
		};
		this.blockClicked = this.blockClicked.bind(this);
	}

	blockClicked() {
		document.getElementById(this.props.id).style.color = "white";
		document.getElementById("index" + this.props.id).style.color =
			"rgb(0, 255, 0)";
	}

	render() {
		return (
			<div
				onClick={this.blockClicked}
				id={this.props.id}
				className="block"
			>
				{this.state.blockValue}
			</div>
		);
	}
}

let arr = [];
let indices = [];

for (let i = 0; i < 10; i++) {
	arr.push(<Block id={String(i)} />);
}
for (let index = 0; index < arr.length; index++) {
	indices.push(
		<div id={"index" + String(index)} className="indices">
			{index}
		</div>
	);
}

export default class Accessing extends React.Component {
	componentDidMount() {
		document.title = 'Accessing in Arrays | Array Bundle';
		window.scroll(0,0);
	}
		
	render() {
		return (
			<div className="subbundle-main">
				<h1 style={{textAlign: 'center', fontFamily: 'Gilroy', textDecoration: 'underline', fontSize: '2rem'}}><Link to="/">Go to Home</Link></h1>
				<h1>Accessing in Arrays</h1>
				<p>
					Although, we store similar data items into a group called array
					which is referenced to by a single name like{" "}
					<code>marks, temp,</code> etc. as seen previously, however in
					order to retrieve and access the elements we do not have a
					single operation.
				</p>
				<p>
					We need to use loops for this purpose. We access the elements by
					incrementing the value of the <b>index/subscript</b>. These
					subscripts are integer values.
				</p>
				<img src="https://www.studymite.com/wp-content/uploads/2018/11/accessing-array-in-c.png" />
				<p>
					In the above example, we are accessing initially the first
					element of the array which is at the 0th index, hence the{" "}
					<b>counter</b> <code>i=0</code>. Then we assign value to it
					using the assignment operator. Similarly, we access and assign
					value to each element until the last one which is located at 9th
					index, hence <code>{"i<10"}</code>. Because if we put{" "}
					<code>{"i<=10"}</code>; then what happens is when{" "}
					<code>i==10</code>; there is no <code>rollno[10]</code> as a
					part of the array; because the last index is 9 as array
					initialises from 0.
				</p>
				<p>
					This leads us to an important conclusion. In order to access or
					do any operation on array elements, we have to use loop and
					perform the same operation on each element by iterating the
					index value.
				</p>
				<hr />
				<h1>GAME TIME!</h1>
				<div className="subbundle-game-container">
					<h1 style={{ textAlign: "center", fontFamily: "Poppins" }}>
						Click on the individual array element boxes <br /> to reveal
						the element and its index in the array..
					</h1>
					<div className="arr">{arr}</div>
					<div className="arr">{indices}</div>
				</div>
				<div className="next-previous-div">
					<Link to="/games/arrays/addressing">
						<span>
							Next{">"} <b>Addressing in Arrays</b>
						</span>
					</Link>
				</div>
			</div>
		);
	}
}
